/*
 * Opens Shopify's passwordless sign-in sheet (<shopify-account id="EaAccountSheet">, rendered by
 * snippets/epk-club-drawer.liquid) from any element with data-ea-signin. The sheet sits under
 * the header; whatever opened it (Club drawer, pop-up) closes first. If the component isn't
 * there, the trigger's own href (Shopify's sign-in page) is followed instead.
 */
(function () {
  'use strict';

  function sheetButton() {
    var host = document.getElementById('EaAccountSheet');
    if (!host || !host.shadowRoot) return null;
    return { host: host, button: host.shadowRoot.querySelector('[part~="signed-out-avatar"]') };
  }

  function headerBottom() {
    var header = document.querySelector('sticky-header, .section-header, header');
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ea-signin]');
    if (!trigger) return;
    var sheet = sheetButton();
    if (!sheet || !sheet.button) return; // plain link fallback
    event.preventDefault();

    var wait = 0;
    var drawer = document.getElementById('EpkClubDrawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') {
      drawer.close();
      wait = 280;
    }
    document.dispatchEvent(new CustomEvent('ea:signin-open'));

    sheet.host.style.setProperty('--shopify-account-dialog-position-top', headerBottom() + 8 + 'px');
    // Open after this click has finished, so the sheet's outside-click handler doesn't close it.
    setTimeout(function () {
      sheet.button.click();
    }, wait);
  });
})();
